module.exports = __webpack_public_path__ + "img/login-left.b59e5ef2.png";